import { render, staticRenderFns } from "./materialView.vue?vue&type=template&id=943c06f4"
import script from "./materialView.vue?vue&type=script&lang=js"
export * from "./materialView.vue?vue&type=script&lang=js"
import style0 from "./materialView.vue?vue&type=style&index=0&id=943c06f4&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('943c06f4')) {
      api.createRecord('943c06f4', component.options)
    } else {
      api.reload('943c06f4', component.options)
    }
    module.hot.accept("./materialView.vue?vue&type=template&id=943c06f4", function () {
      api.rerender('943c06f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_meterial/materialView/materialView.vue"
export default component.exports